/*
 * ******************************************************************
 * Copyright (c) 2024 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Context } from "@shared/services/context/context";
import { ContextService } from "@shared/services/context/context.service";

@Injectable({
    providedIn: 'root',
})
export class BreadcrumbService {
    breadcrumbElements: BreadcrumbModel[];

    private currentRoutes: BreadcrumbModel[] = [];

    init(route: ActivatedRoute, contextService: ContextService): void {
        if (contextService) {
            this.currentRoutes = contextService.getBreadcrumbRoutes(route);
            this.breadcrumbElements = this.mapBreadcrumbLabels(contextService.context);
        }
    }

    destroy(): void {
        this.breadcrumbElements = [];
        this.currentRoutes = [];
    }

    mapBreadcrumbLabels(context: Context): BreadcrumbModel[] {
        if (this.currentRoutes.length > 1 && !!context) {
            this.currentRoutes.forEach((el: BreadcrumbModel) => {
                switch (el.label) {
                    case context.id:
                        el.label = context.name;
                        break;
                    case context.parent?.id:
                        el.label = context.parent.name;
                        break
                    case context.parent?.parent?.id:
                        el.label = context.parent.parent.name;
                        break;
                    default:
                        break;
                }
            })
        }
        return this.currentRoutes;
    }
}

export interface BreadcrumbModel {
    /**
     * The label to be displayed.
     */
    label: string;

    /**
     * The url where the navigation goes.
     */
    url?: string;
}
